window.stockStatusApp = window.stockStatusApp || {};

/**
 * Fetch inventory levels for a given SKU from Shopify
 * @param {string} sku - The SKU to query
 * @returns {Promise<Object>} - The inventory data from Shopify
 */
async function bbdFetchStockStatus(sku) {
  const url = `https://music-all-in-backend.fly.dev/api/delivery/${encodeURIComponent(sku)}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Inventory API error: ${response.status} ${response.statusText}`);
  }
  return response.json();
}

window.stockStatusApp.fetchStockStatus = async function (variant) {
  try {
    return await bbdFetchStockStatus(variant.sku);
  } catch (e) {
    console.error(`Error fetching stock status for variant '${variant.sku}':`, e);
  }
  return null;
};

window.stockStatusApp.fetchBundleStatus = async function (handle) {
  try {
    const url = `https://music-all-in-backend.fly.dev/api/bundle/${encodeURIComponent(handle)}`;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Bundle API error: ${response.status} ${response.statusText}`);
    }
    return response.json();
  } catch (e) {
    console.error(`Error fetching bundle status for '${handle}':`, e);
  }
  return null;
};
